import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../context/SubscriptionContext';
import { formatPrice } from '../utils/formatHelper';

function Complete() {
  const navigate = useNavigate();
  const { resetPackage, items, subscriptionType, totalPrice } = useSubscription();
  const discountedPrice = totalPrice * (1 - (subscriptionType?.discount) / 100);

  useEffect(() => {
    // Reset package after 5 seconds
    const timer = setTimeout(() => {
      resetPackage();
    }, 5000);

    return () => clearTimeout(timer);
  }, [resetPackage]);

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 text-center">
          <div className="display-1 text-success mb-4">
            <i className="fas fa-check-circle"></i>
          </div>
          
          <h1 className="text-olive mb-4">Aboneliğiniz Başarıyla Oluşturuldu!</h1>
          
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <h5 className="card-title mb-4">Abonelik Detayları</h5>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="text-muted mb-2">Abonelik Tipi</div>
                  <div className="h5">{subscriptionType?.title}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="text-muted mb-2">Toplam Tutar</div>
                  <div className="h5 text-orange">
                    {discountedPrice ? (
                      <>
                        <span className="text-decoration-line-through text-muted me-2">
                          {formatPrice(totalPrice)}
                        </span>
                        <span className="text-orange fw-bold">
                          {formatPrice(discountedPrice)}
                        </span>
                      </>
                    ) : (
                      <span className="text-orange fw-bold">
                        {formatPrice(totalPrice)}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="text-muted mb-2">Seçilen Ürünler</div>
              <ul className="list-group list-group-flush">
                {items.map(item => (
                  <li key={item.id} className="list-group-item d-flex justify-content-between align-items-center">
                    <span>{item.name}</span>
                    <span className="badge bg-olive rounded-pill">{item.quantity}x</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <p className="text-muted mb-4">
            Aboneliğiniz başarıyla oluşturuldu. İlk teslimatınız en kısa sürede hazırlanacak.
            <br />
            Siparişinizle ilgili tüm güncellemeleri e-posta adresinize göndereceğiz.
          </p>

          <button
            className="btn btn-orange btn-lg"
            onClick={() => navigate('/dashboard')}
          >
            Ana Sayfaya Dön
          </button>
        </div>
      </div>
    </div>
  );
}

export default Complete; 